export const maximumPlayerCount = 6
